export class RestoreAvailabilityZones {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZones",
            "baseName": "availabilityZones",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAvailabilityZones.attributeTypeMap;
    }
    constructor() {
    }
}
